import { isEmpty } from 'remeda'
import { useLiquidSkeleton } from '@velasca/hooks/use-liquid-skeleton'
import { ArrowIcon } from '@velasca/icons/arrow'
import type { CategoriesGridCardProps } from '@velasca/types'
import { SansTitle } from '@velasca/ui/sans-title'
import { TitleComposition } from '@velasca/ui/title-composition'
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import {
  CollectionCardTitleWrapper,
  CollectionCardWrapper,
  Container,
  Grid,
  Image,
  ImageContainer,
} from './CategoriesGrid.style'
import type { CategoriesGridProps } from './CategoriesGrid.types'

const CollectionCard = ({ title, image, url }: CategoriesGridCardProps) => {
  return (
    <CollectionCardWrapper href={url}>
      {image && (
        <ImageContainer>
          <Image
            lqip
            lazyload
            alt={image.alt}
            sources={buildIntrinsicWidthSources({ src: image.src })}
            imgSrc={setQueryParams(image.src, [{ name: 'width', value: '30' }])}
          />
        </ImageContainer>
      )}

      {title && (
        <CollectionCardTitleWrapper>
          <SansTitle tracking="wide" as="h3">
            {title}
          </SansTitle>
          <ArrowIcon />
        </CollectionCardTitleWrapper>
      )}
    </CollectionCardWrapper>
  )
}

export const CategoriesGrid = ({
  title,
  cards,
  mobileLayout = 'doubleColumn',
}: CategoriesGridProps) => {
  useLiquidSkeleton('#categories-grid-block')

  if (title === undefined || title === '' || isEmpty(cards)) {
    return null
  }

  return (
    <Container>
      {title && <TitleComposition title={title} upperTitle={''} />}
      <Grid mobileLayout={mobileLayout}>
        {cards.map((card) => (
          <CollectionCard key={card.id ?? card.title ?? card.url} {...card} />
        ))}
      </Grid>
    </Container>
  )
}
